import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "signup-progress-overlay"
}
const _hoisted_2 = { class: "signup-progress-heading" }
const _hoisted_3 = { id: "signup-progress-title" }
const _hoisted_4 = {
  id: "signup-progress-description",
  class: "signup-progress-description"
}
const _hoisted_5 = { class: "signup-steps" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "signup-step-copy" }
const _hoisted_8 = {
  key: 0,
  class: "signup-error-message"
}
const _hoisted_9 = {
  key: 1,
  class: "signup-progress-actions"
}

import { AButton, AIcon } from '@adereso-ai/vue-components'
import type { SignupFlowStatus, SignupStep } from '@/composables/useEmbeddedSignup'

interface Props {
  visible: boolean
  title: string
  description: string
  steps: SignupStep[]
  errorMessage: string
  flowStatus: SignupFlowStatus
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SignupProgressModal',
  props: {
    visible: { type: Boolean },
    title: {},
    description: {},
    steps: {},
    errorMessage: {},
    flowStatus: {}
  },
  emits: ["close"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_card, {
          class: "signup-progress-card",
          variant: "flat",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "signup-progress-title",
          "aria-describedby": "signup-progress-description"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(AIcon), {
                icon: "tabler:brand-meta",
                color: "primary",
                size: "22",
                "with-container": ""
              }),
              _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1)
            ]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: step.key,
                  class: "signup-step"
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["signup-step-indicator", `is-${step.status}`]),
                    role: "img",
                    "aria-label": step.status.replace('_', ' ')
                  }, null, 10, _hoisted_6),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("strong", null, _toDisplayString(step.title), 1),
                    _createElementVNode("p", null, _toDisplayString(step.description), 1)
                  ])
                ]))
              }), 128))
            ]),
            (__props.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.errorMessage), 1))
              : _createCommentVNode("", true),
            (__props.flowStatus === 'error' || __props.flowStatus === 'success')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_unref(AButton), {
                    variant: "outlined",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" Close ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})